var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPieAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6284 8.83107H6.13792V2.34061C6.13792 2.09414 5.89145 1.87505 5.64497 1.90244C2.38605 2.368 -0.106067 5.21613 0.00347659 8.63937C0.11302 12.0352 2.93377 14.856 6.32962 14.9655C9.75286 15.0751 12.601 12.5829 13.0666 9.32402C13.0939 9.07755 12.8749 8.83107 12.6284 8.83107ZM7.89062 0.971315C7.64415 0.943929 7.45245 1.16302 7.45245 1.40949V7.51655H13.5595C13.806 7.51655 14.0251 7.32485 13.9977 7.07837C13.7786 3.79206 11.1769 1.1904 7.89062 0.971315Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPieAlt);
export default __webpack_public_path__ + "static/media/chart-pie-alt.0b187cf03134654f9f936ac1004bc722.svg";
export { ForwardRef as ReactComponent };